// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RNpk","content":"styles_content__2id0a","row":"styles_row__4IZEZ","footer":"styles_footer__eUj8p","phraseLength":"styles_phraseLength__m2tsz"};